import { CSVItemError } from "./CSVItemError"

/**
 * Wrapper error for iterable list of CSVItemError items
 */
export class CSVError extends Error {
    /**
     * @param itemArray CSVItemError array
     */
    constructor(public readonly itemArray: CSVItemError[]) {
        super("Invalid CSV")
        this.name = "CSVError"
    }
}
